// extracted by mini-css-extract-plugin
export var bounce = "_lq-1";
export var generatingText = "_lq-6";
export var lightning = "_lq-4";
export var popup = "_lq-5";
export var progressBar = "_lq-7";
export var progressFill = "_lq-8";
export var progressShimmer = "_lq-9";
export var progressText = "_lq-a";
export var shimmer = "_lq-3";
export var uploadIcon = "_lq-0";
export var uploadingText = "_lq-2";